<h2 class="dsd-t-4" tabindex="-1">{{ 'caad.valider.courriel.titre' | translate }}</h2>
<div *ngIf="isMultiple; else courrielSimple">
  <ng-container *ngFor="let compte of comptesAffichable; let last = last">
    <p class="dsd-m-0">
      <span class="libelle"
        >{{ 'caad.valider.courriel.libelle.courrielMultiple' | translate }}
        {{ compte.descriptionCourte | titlecase }}
        <span class="dsd-sr-only"
          >{{ 'caad.accueil.libelle.horsEcran.carteCreditTerminant' | translate
          }}{{ compte.numeroCarte.substring(12, 16) }}</span
        >
        <span aria-hidden="true">{{ compte.numeroCarte | masquerCarte }}</span>
      </span>
    </p>
    <p *ngIf="compte.adresseCourriel" class="valeur texte-courriel">{{ compte.adresseCourriel }}</p>
    <p *ngIf="!compte.adresseCourriel" class="valeur texte-courriel">
      {{ 'caad.modifier.courriel.libelle.adresseCourrielVide' | translate }}
    </p>
  </ng-container>
</div>

<ng-template #courrielSimple>
  <p class="dsd-mb-0">
    <span class="libelle">{{ 'caad.valider.courriel.libelle.courriel' | translate }}&nbsp;</span>
    <span class="valeur">{{ requeteModifierCoordonnees.infosComptes[0].adresseCourriel }}</span>
  </p>
</ng-template>
